export const MASTER_PARAM_KEY = `master`;
export const CARD_PARAM_KEY = "iD";

export const PREMADE_MASTER_PARAM_KEY = `pMaster`;
export const PREMADE_CARD_PARAM_KEY = `piD`;
